// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/between-vertical-end.js';

import { paths } from '../generated/between-vertical-end';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('between-vertical-end', Original, paths);
